var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83336 5.33335L1.2442 5.92251L0.655029 5.33335L1.2442 4.74418L1.83336 5.33335ZM16 12C16 12.221 15.9122 12.433 15.756 12.5893C15.5997 12.7456 15.3877 12.8333 15.1667 12.8333C14.9457 12.8333 14.7337 12.7456 14.5774 12.5893C14.4212 12.433 14.3334 12.221 14.3334 12H16ZM5.41086 10.0892L1.2442 5.92251L2.42253 4.74418L6.5892 8.91085L5.41086 10.0892ZM1.2442 4.74418L5.41086 0.577515L6.5892 1.75585L2.42253 5.92251L1.2442 4.74418ZM1.83336 4.50001H10.1667V6.16668H1.83336V4.50001ZM16 10.3333V12H14.3334V10.3333H16ZM10.1667 4.50001C11.7138 4.50001 13.1975 5.1146 14.2915 6.20856C15.3854 7.30252 16 8.78625 16 10.3333H14.3334C14.3334 9.22828 13.8944 8.16847 13.113 7.38707C12.3316 6.60567 11.2718 6.16668 10.1667 6.16668V4.50001Z",
    fill: "#14191E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.d1b84586b22323a7b9fa6e2e43c41709.svg";
export { ForwardRef as ReactComponent };